import { useMemo, useState } from 'react';
import type { VoiceMessage } from '@orborix/voice-client';
import { completionCount, selectSkillChips } from '../skillChips.js';

/**
 * Tick that goes up when a bubble earns a skill-completion chip (W6, D7): the
 * shells feed it to a `sparkles` CelebrationLayer — small, contained, no sound.
 * Counted from the mount, so remounting the shell (mobile ↔ desktop) or a
 * re-render never replays a celebration that already happened.
 */
export function useSkillCompletionTick(messages: ReadonlyArray<VoiceMessage>): number {
  const count = useMemo(() => completionCount(selectSkillChips(messages)), [messages]);
  const [baseline] = useState(count);
  return Math.max(0, count - baseline);
}
